export default __webpack_public_path__ + "static/media/emailIcon.5aad4621.png";